var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-table",
    { attrs: { border: "", data: _vm.tableData } },
    [
      _vm._l(_vm.columns, function(col, index) {
        return [
          col.slot
            ? _c("el-table-column", {
                key: "column" + index,
                attrs: { prop: col.prop, width: col.width },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "header",
                      fn: function(scope) {
                        return [
                          _c("span", [
                            _vm._v(
                              "\n            " +
                                _vm._s(col.label) +
                                "\n          "
                            )
                          ]),
                          col.prop === "useFileAuditFlag"
                            ? _c(
                                "el-tooltip",
                                {
                                  attrs: {
                                    effect: "light",
                                    content: "",
                                    placement: "top"
                                  }
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      attrs: { slot: "content" },
                                      slot: "content"
                                    },
                                    [
                                      _vm._v(
                                        "\n              开启后，如果当前审批流程中的审批人已参与了文件发起审批，则不需要再进行用印审批。\n            "
                                      )
                                    ]
                                  ),
                                  _c("i", {
                                    staticClass: "el-icon-question",
                                    staticStyle: {
                                      "font-size": "16px",
                                      "margin-left": "3px",
                                      color: "#a1a1a1",
                                      cursor: "pointer"
                                    }
                                  })
                                ]
                              )
                            : _vm._e()
                        ]
                      }
                    },
                    {
                      key: "default",
                      fn: function(scope) {
                        return [
                          _c(col.slot, {
                            tag: "component",
                            attrs: { data: scope.row },
                            on: { reloadList: _vm.reloadList }
                          })
                        ]
                      }
                    }
                  ],
                  null,
                  true
                )
              })
            : _c("el-table-column", {
                key: "column" + index,
                attrs: {
                  "show-overflow-tooltip": "",
                  prop: col.prop,
                  label: col.label,
                  width: col.width
                }
              })
        ]
      }),
      _c("no-data", {
        attrs: { slot: "empty", text: "暂无数据" },
        slot: "empty"
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d087d6a6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d087d6a6","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/corp-comps/FlowTable.vue
// module id = P7ne
// module chunks = 7 30 56 114